import { c as _c } from "react/compiler-runtime";
import { Tooltip } from 'platform/components';
import { Icon } from 'platform/foundation-tw';
import { match } from 'ts-pattern';
import { CellRendererProps } from '../../types/CellRendererProps';
import { TooltipGetter } from '../../types/TooltipGetter';
import { getTooltipProps } from '../../utils/getTooltipProps';
type CheckboxCellRendererProps = CellRendererProps<boolean | null> & {
  getTooltipProps?: TooltipGetter;
};
export function CheckboxCellRenderer(props) {
  const $ = _c(11);
  let t0;
  if ($[0] !== props.getTooltipProps || $[1] !== props.row) {
    t0 = getTooltipProps(props.row, {}, props.getTooltipProps);
    $[0] = props.getTooltipProps;
    $[1] = props.row;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const tooltipProps = t0;
  const isTruthy = !!props.value;
  let t1;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      display: "inline-flex"
    };
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== isTruthy) {
    t2 = match(isTruthy).with(true, _temp).otherwise(_temp2);
    $[4] = isTruthy;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t2) {
    t3 = <span style={t1}>{t2}</span>;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t3 || $[9] !== tooltipProps) {
    t4 = <Tooltip {...tooltipProps}>{t3}</Tooltip>;
    $[8] = t3;
    $[9] = tooltipProps;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
}
function _temp2() {
  return <Icon value="navigation/cancel" size={6} color="severity.danger" />;
}
function _temp() {
  return <Icon value="action/check_circle" size={6} color="severity.success" />;
}